import React from 'react';
import Plot from 'react-plotly.js';

export const ChartBlock = ({ data, layout }) => {
  const plotlyData = Array.isArray(data) ? data : [data];
  const plotlyLayout = layout || {};

  return (
    <div className="chart-block">
      <Plot
        data={plotlyData}
        layout={{
          ...plotlyLayout,
          autosize: true,
          responsive: true,
          margin: { l: 50, r: 50, t: 50, b: 50 }
        }}
        style={{ width: '100%', height: '400px' }}
        config={{ 
          displayModeBar: true, // Always show the toolbar
          displaylogo: false, // Hide the Plotly logo
          responsive: true,
          staticPlot: false,
          doubleClick: false,
          showTips: false,
          // Optionally remove specific toolbar buttons:
          // modeBarButtonsToRemove: ['pan2d', 'lasso2d', 'select2d', 'sendDataToCloud']
          // Available buttons to remove: 'pan2d', 'lasso2d', 'select2d', 'autoScale2d', 
          // 'resetScale2d', 'hoverClosestCartesian', 'hoverCompareCartesian', 'zoom2d', 
          // 'zoomIn2d', 'zoomOut2d', 'toImage', 'sendDataToCloud', 'resetViews', 
          // 'toggleHover', 'toggleSpikelines'
        }}
      />
    </div>
  );
};

